var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-card-child"},[_c('div',{directives:[{name:"watermark",rawName:"v-watermark",value:({
      text: _vm.text,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }),expression:"{\n      text: text,\n      textColor: 'rgba(180, 180, 180, 0.3)',\n    }"}],staticClass:"select-card-bottom"},[_c('div',{attrs:{"id":"china_map_box"}},[_c('div',{style:({ height: '400px' }),attrs:{"id":"china_map"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }